import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { SUPPORTED_LANGUAGES } from '@source/constants/config';

import sharedEn from '@source/lang/en.json';
import sharedId from '@source/lang/id.json';
import sharedMy from '@source/lang/my.json';
import sharedTh from '@source/lang/th.json';
// import sharedTw from '@source/lang/tw.json';
import sharedJa from '@source/lang/ja.json';
import sharedZhSg from '@source/lang/zhSg';
import sharedMsSg from '@source/lang/msSg';
import sharedZhHanS from '@source/lang/zhHanS.json';
import sharedZhHanT from '@source/lang/zhHanT.json';
import { COOKIE_KEYS } from './constants/common';

const resources = {
  [SUPPORTED_LANGUAGES.EN.code]: {
    translation: {
      shared: sharedEn,
    },
    common: {
      shared: sharedEn,
    },
  },
  // Bahasa Indonesia
  [SUPPORTED_LANGUAGES.ID.code]: {
    translation: {
      shared: sharedId,
    },
    common: {
      shared: sharedId,
    },
  },
  // Bahasa Maylaysia
  [SUPPORTED_LANGUAGES.MY.code]: {
    translation: {
      shared: sharedMy,
    },
    common: {
      shared: sharedMy,
    },
  },
  // Thai
  [SUPPORTED_LANGUAGES.TH.code]: {
    translation: {
      shared: sharedTh,
    },
    common: {
      shared: sharedTh,
    },
  },
  // Taiwanese Mandarin (Note: i18next support zh-TW not zh-tw)
  // [SUPPORTED_LANGUAGES.TW.code]: {
  //   translation: {
  //     ...homeTw,
  //     ...sellCarTw,
  //     ...sellConfirmationTw,
  //     shared: sharedTw,
  //     details: carDetailTw,
  //     error: errorTw,
  //     inspection: inspectionTw,
  //     userProfile: userProfileTw,
  //     contactUs: contactUsTw,
  //     viewingHistory: viewingHistoryTW,
  //     ccpo: ccpoTw,
  //     locateUs: locateUsTw,
  //     promotionsNFC: PromotionsNFCTw,
  //   },
  // },
  // Singapore Mandarin (Note: i18next support zh-SG)
  [SUPPORTED_LANGUAGES['ZH-SG'].code]: {
    translation: {
      shared: sharedZhSg,
    },
    common: {
      shared: sharedZhSg,
    },
  },
  // Malaysia Mandarin (Note: i18next support zh-MY)
  [SUPPORTED_LANGUAGES['ZH-MY'].code]: {
    translation: {
      shared: sharedZhSg,
    },
    common: {
      shared: sharedZhSg,
    },
  },
  // Japanese
  [SUPPORTED_LANGUAGES.JA.code]: {
    // TODO - UPDATE JP Translation files
    translation: {
      shared: sharedJa,
    },
    common: {
      shared: sharedJa,
    },
  },
  // Bahasa Maylaysia for SG region
  [SUPPORTED_LANGUAGES['MS-SG'].code]: {
    translation: {
      shared: sharedMsSg,
    },
    common: {
      shared: sharedMsSg,
    },
  },
  [SUPPORTED_LANGUAGES['ZH-HANS-HK'].code]: {
    // TODO - UPDATE SC hongkong Translation files
    translation: {
      shared: sharedZhHanS,
    },
    common: {
      shared: sharedZhHanS,
    },
  },
  [SUPPORTED_LANGUAGES['ZH-HANT-HK'].code]: {
    // TODO - UPDATE TC hongkong Translation files
    translation: {
      shared: sharedZhHanT,
    },
    common: {
      shared: sharedZhHanT,
    },
  },
};

i18n
  .use(LanguageDetector) // detect user language
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    detection: {
      order: ['path', 'cookie'],
      lookupFromPathIndex: 1,
      lookupCookie: COOKIE_KEYS.USER_CURRENT_LANGUAGE,
    },
    resources,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
